import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeaturedMovies from "@/pages/home/components/FeaturedMovies";
import MovieExplorer from "@/pages/home/components/MovieExplorer";
import ActionSection from "@/pages/home/components/ActionSection";
import ScifiSection from "@/pages/home/components/ScifiSection";
import HorrorSection from "@/pages/home/components/HorrorSection";
import RomanceSection from "@/pages/home/components/RomanceSection";
import ComedySection from "@/pages/home/components/ComedySection";
import TvSection from "@/pages/home/components/TvSection";
import RankingBoard from "@/pages/home/components/RankingBoard";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CategoryGrid />
        <FeaturedMovies />
        <MovieExplorer />
        <ActionSection />
        <ScifiSection />
        <HorrorSection />
        <RomanceSection />
        <ComedySection />
        <TvSection />
        <RankingBoard />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}